// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"css/app/app","170":"css/app","654":"css/icon"}[chunkId] + ".css";
};